import { getDeviceBreakpoint, getDeviceBreakpointGroup } from '@/helper/Breakpoints';
import throttle from 'lodash/throttle';
import { useEffect, useMemo, useState } from 'react';

export const useBreakPoint = () => {

    const dimensions = useMemo(() => {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    }, [window.innerWidth, window.innerHeight]);

    const templateHeights = useMemo(() => ({
        header: 165,
        footer: 577
    }), []);

    const [ breakpointGroup, setBreakpointGroup ] = useState(() => ({
        device: getDeviceBreakpoint(window.innerWidth),
        group: getDeviceBreakpointGroup(window.innerWidth)
    }));
    
    useEffect(() => {
        const calcInnerWidth = throttle(function() {
            setBreakpointGroup({
                device: getDeviceBreakpoint(window.innerWidth),
                group: getDeviceBreakpointGroup(window.innerWidth)
            });

        }, 200);

        window.addEventListener('resize', calcInnerWidth);
        return () => 
            window.removeEventListener('resize', calcInnerWidth);
        
    }, []);

    return {...breakpointGroup, dimensions, templateHeights};
};